import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const LayoutToggleContext = createContext();
const RedesignTabsContext = createContext({
  pageTabs: [],
  setPageTabs: () => {},
  clearPageTabs: () => {},
  showLocationSwitcher: false,
  setShowLocationSwitcher: () => {},
});

export const useLayoutToggle = () => useContext(LayoutToggleContext);
export const useRedesignTabs = () => useContext(RedesignTabsContext);

export const LayoutToggleProvider = ({ children }) => {
  const [useRedesign, setUseRedesign] = useState(() => {
    // Old layout only for now — ignore stored redesign preference.
    return false;
    // try {
    //   const stored = localStorage.getItem("carecentre_use_redesign");
    //   return stored === "true";
    // } catch (e) {
    //   return false;
    // }
  });

  const [pageTabs, setPageTabsState] = useState([]);
  const [showLocationSwitcher, setShowLocationSwitcherState] = useState(false);

  const toggleLayout = () => {
    setUseRedesign((prev) => {
      const newVal = !prev;
      localStorage.setItem("carecentre_use_redesign", String(newVal));
      return newVal;
    });
  };

  const setPageTabs = useCallback((tabs) => {
    setPageTabsState(Array.isArray(tabs) ? tabs : []);
  }, []);

  const clearPageTabs = useCallback(() => {
    setPageTabsState([]);
  }, []);

  const setShowLocationSwitcher = useCallback((show) => {
    setShowLocationSwitcherState(Boolean(show));
  }, []);

  const tabsValue = useMemo(
    () => ({
      pageTabs,
      setPageTabs,
      clearPageTabs,
      showLocationSwitcher,
      setShowLocationSwitcher,
    }),
    [
      pageTabs,
      setPageTabs,
      clearPageTabs,
      showLocationSwitcher,
      setShowLocationSwitcher,
    ],
  );

  return (
    <LayoutToggleContext.Provider value={{ useRedesign, toggleLayout }}>
      <RedesignTabsContext.Provider value={tabsValue}>
        {children}
      </RedesignTabsContext.Provider>
    </LayoutToggleContext.Provider>
  );
};
